/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LatestTransaction } from './LatestTransaction';
import {
    LatestTransactionFromJSON,
    LatestTransactionFromJSONTyped,
    LatestTransactionToJSON,
} from './LatestTransaction';

/**
 * 
 * @export
 * @interface LatestTransactionsViewModel
 */
export interface LatestTransactionsViewModel {
    /**
     * 
     * @type {Array<LatestTransaction>}
     * @memberof LatestTransactionsViewModel
     */
    latestTransactions: Array<LatestTransaction>;
}

/**
 * Check if a given object implements the LatestTransactionsViewModel interface.
 */
export function instanceOfLatestTransactionsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "latestTransactions" in value;

    return isInstance;
}

export function LatestTransactionsViewModelFromJSON(json: any): LatestTransactionsViewModel {
    return LatestTransactionsViewModelFromJSONTyped(json, false);
}

export function LatestTransactionsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestTransactionsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestTransactions': ((json['LatestTransactions'] as Array<any>).map(LatestTransactionFromJSON)),
    };
}

export function LatestTransactionsViewModelToJSON(value?: LatestTransactionsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'LatestTransactions': ((value.latestTransactions as Array<any>).map(LatestTransactionToJSON)),
    };
}

